module.exports = __webpack_public_path__ + "static/media/maxParties_15_20.1b89762a.png";